import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinmumbai() {



    const cardData = {

keyword: "Cab Service in Mumbai",

headingDescription:
    "Mumbai Airport Cab offers reliable, safe, and affordable Cab Service in Mumbai for local travel, airport transfers, corporate travel, outstation trips, and daily commuting needs. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with professional and experienced chauffeurs. With 24/7 availability, doorstep pickup and drop across all Mumbai locations, real-time booking support, transparent pricing, and comfortable rides, we ensure a smooth and hassle-free travel experience for every passenger in Mumbai and surrounding areas.",

topPlaces: [
    {
        title: "Gateway of India",
        description:
            "Gateway of India is one of Mumbai’s most iconic landmarks located in Colaba. Overlooking the Arabian Sea, it attracts thousands of visitors daily. Tourists enjoy ferry rides to Elephanta Caves, photography, street shopping, and the lively atmosphere around the monument, making it a must-visit attraction in Mumbai."
    },
    {
        title: "Marine Drive",
        description:
            "Marine Drive is a scenic 3.6 km long promenade also known as the Queen’s Necklace due to its sparkling night lights. It is a popular spot for evening walks, relaxing by the sea, watching sunsets, and enjoying the cool sea breeze. The stunning skyline makes it one of Mumbai’s most peaceful attractions."
    },
    {
        title: "Juhu Beach",
        description:
            "Juhu Beach is one of the most famous beaches in Mumbai, known for its lively atmosphere, street food stalls, and sunset views. Visitors enjoy local snacks like pav bhaji, bhel puri, and pani puri while walking along the sandy shoreline, making it a favorite family and tourist destination."
    },
    {
        title: "Siddhivinayak Temple",
        description:
            "Siddhivinayak Temple is one of Mumbai’s most revered religious sites dedicated to Lord Ganesha. Devotees from across India visit to seek blessings. The temple is known for its spiritual energy, beautiful idol of Lord Ganesha, and organized darshan system."
    },
    {
        title: "Haji Ali Dargah",
        description:
            "Haji Ali Dargah is a famous Islamic shrine located on a small islet off the coast of Mumbai. Connected by a narrow causeway, it offers a unique spiritual experience with stunning sea views. It is visited by people of all faiths seeking blessings and peace."
    },
    {
        title: "Chhatrapati Shivaji Maharaj Terminus",
        description:
            "Chhatrapati Shivaji Maharaj Terminus (CSMT) is a UNESCO World Heritage Site and one of Mumbai’s most beautiful railway stations. Known for its Victorian Gothic architecture, intricate design, and historical importance, it is a major landmark in the city."
    },
    {
        title: "Colaba Causeway",
        description:
            "Colaba Causeway is a bustling street shopping destination offering clothes, accessories, souvenirs, and street food. It is popular among tourists for its vibrant atmosphere, affordable shopping, and proximity to major attractions like Gateway of India."
    },
    {
        title: "Bandra-Worli Sea Link",
        description:
            "Bandra-Worli Sea Link is a modern engineering marvel that connects western suburbs to South Mumbai. The bridge offers a smooth driving experience with stunning views of the Arabian Sea and Mumbai skyline, especially beautiful at night when illuminated."
    },
    {
        title: "Sanjay Gandhi National Park",
        description:
            "Sanjay Gandhi National Park is a large protected area within Mumbai featuring rich biodiversity, nature trails, Kanheri Caves, and wildlife. It offers a peaceful escape from city life and is ideal for nature lovers, trekking, and family outings."
    },
    {
        title: "Elephanta Caves",
        description:
            "Elephanta Caves are ancient rock-cut caves located on Elephanta Island, accessible via ferry from the Gateway of India. The caves feature stunning sculptures dedicated to Lord Shiva and are recognized as a UNESCO World Heritage Site, making them a major cultural attraction."
    }
],



services: [
{
name: "Cab Service in Mumbai",
description: "Mumbai Airport Cab provides professional Cab Service in Mumbai for local travel, airport transfers, business meetings, corporate travel, family outings, shopping trips, sightseeing, and daily commuting needs. We offer a wide range of well-maintained AC vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Force Urbania, and luxury cars to suit every budget and group size. Our trained and experienced chauffeurs ensure safe, punctual, and comfortable rides across Mumbai, Navi Mumbai, Thane, and nearby regions. With 24x7 availability, doorstep pickup, transparent pricing, and easy online booking, we deliver a seamless and reliable travel experience for all passengers."
},
{
name: "Mumbai Cab Service",
description: "Book Mumbai Cab Service with Mumbai Airport Cab for convenient and hassle-free travel across the city. We provide clean AC vehicles, professional drivers, affordable fares, and flexible booking options suitable for daily travel, business trips, and personal journeys."
},
{
name: "Mumbai Taxi Service",
description: "Mumbai Airport Cab offers Mumbai Taxi Service with safe, reliable, and comfortable transportation across all major Mumbai locations. Our taxis are available 24x7 for local rides, airport transfers, and outstation travel."
},
{
name: "Best Cab Service Mumbai",
description: "Choose Best Cab Service Mumbai with Mumbai Airport Cab for premium quality travel, well-maintained vehicles, experienced chauffeurs, on-time pickup, and excellent customer support for all travel needs."
},
{
name: "24x7 Cab Service Mumbai",
description: "Mumbai Airport Cab provides 24x7 Cab Service Mumbai ensuring round-the-clock availability for airport transfers, emergency travel, night rides, and early morning bookings with complete reliability."
},
{
name: "Affordable Cab Service Mumbai",
description: "Get Affordable Cab Service Mumbai with budget-friendly pricing, transparent billing, and economical travel options without compromising comfort, safety, or service quality."
},
{
name: "Mumbai Car Hire Service",
description: "Book Mumbai Car Hire Service with chauffeur-driven vehicles for flexible travel across the city. Choose from Sedan, SUV, Innova, and luxury cars for personal, corporate, and family use."
},
{
name: "Local Cab Service Mumbai",
description: "Mumbai Airport Cab offers Local Cab Service Mumbai for intra-city travel including short trips, shopping rides, office commutes, and daily transportation with reliable drivers and clean vehicles."
},
{
name: "Mumbai Outstation Cab Service",
description: "Travel comfortably with Mumbai Outstation Cab Service for long-distance trips to Pune, Lonavala, Goa, Nashik, Shirdi, Indore, and other destinations with safe and experienced chauffeurs."
},
{
name: "Mumbai Airport Cab Service",
description: "Mumbai Airport Cab Service provides direct pickup and drop from Chhatrapati Shivaji Maharaj International Airport with flight tracking, luggage assistance, and timely arrivals for stress-free travel."
},
{
name: "Mumbai Corporate Cab Service",
description: "Mumbai Airport Cab offers Mumbai Corporate Cab Service for business meetings, employee transportation, client visits, and corporate events with premium vehicles and professional chauffeurs."
},
{
name: "Mumbai Family Cab Service",
description: "Book Mumbai Family Cab Service for safe and comfortable travel with spacious vehicles, child-friendly rides, and reliable chauffeurs ensuring a smooth family journey."
},
{
name: "Mumbai Online Cab Booking",
description: "Mumbai Airport Cab provides Mumbai Online Cab Booking with instant confirmation, easy scheduling, multiple vehicle options, and secure booking for all travel needs."
},
{
name: "Instant Cab Booking Mumbai",
description: "Get Instant Cab Booking Mumbai with quick confirmation, real-time availability, and fast pickup service for urgent travel requirements and planned journeys."
},
{
name: "Reliable Cab Service Mumbai",
description: "Mumbai Airport Cab ensures Reliable Cab Service Mumbai with punctual drivers, well-maintained vehicles, safe driving practices, and consistent service quality."
},
{
name: "Mumbai City Cab Service",
description: "Mumbai City Cab Service covers all major locations including Andheri, Bandra, Borivali, Dadar, Kurla, Powai, Navi Mumbai, and Thane for smooth intra-city travel."
},
{
name: "Mumbai Ride Service",
description: "Mumbai Airport Cab offers Mumbai Ride Service for daily commuting, short trips, airport transfers, and flexible travel needs with affordable and comfortable rides."
},
{
name: "Mumbai Travel Cab Service",
description: "Book Mumbai Travel Cab Service for personal, corporate, and leisure travel with premium vehicles, professional drivers, and flexible scheduling options."
},
{
name: "Mumbai Budget Cab Service",
description: "Mumbai Airport Cab provides Mumbai Budget Cab Service with cost-effective travel solutions, economical fares, and reliable transportation for everyday use."
},
{
name: "Mumbai Premium Cab Service",
description: "Choose Mumbai Premium Cab Service for luxury travel experience with high-end vehicles, professional chauffeurs, plush interiors, and top-class comfort."
}
],

tableData: [
["Cab Service in Mumbai","Mumbai Cab Service"],
["Mumbai Taxi Service","Best Cab Service Mumbai"],
["24x7 Cab Service Mumbai","Affordable Cab Service Mumbai"],
["Mumbai Car Hire Service","Local Cab Service Mumbai"],
["Mumbai Outstation Cab Service","Mumbai Airport Cab Service"],
["Mumbai Corporate Cab Service","Mumbai Family Cab Service"],
["Mumbai Online Cab Booking","Instant Cab Booking Mumbai"],
["Reliable Cab Service Mumbai","Mumbai City Cab Service"],
["Mumbai Ride Service","Mumbai Travel Cab Service"],
["Mumbai Budget Cab Service","Mumbai Premium Cab Service"]
],



whychoose: [
{
WhyChooseheading: "Trusted Cab Service in Mumbai",
WhyChoosedescription: "Mumbai Airport Cabs provides reliable cab services in Mumbai for local travel, airport transfers, outstation trips, corporate transportation, and daily commuting needs."
},
{
WhyChooseheading: "24x7 Cab Availability",
WhyChoosedescription: "Our cab service operates round the clock, allowing customers to book rides anytime for business meetings, airport travel, family functions, and emergency transportation."
},
{
WhyChooseheading: "Local and Outstation Travel Solutions",
WhyChoosedescription: "Whether you need a city ride within Mumbai or an outstation journey to Pune, Nashik, Shirdi, Goa, or other destinations, we offer convenient travel options."
},
{
WhyChooseheading: "Wide Range of Vehicles",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles based on their travel requirements and group size."
},
{
WhyChooseheading: "Airport Pickup and Drop Specialists",
WhyChoosedescription: "We provide timely airport transfers from Mumbai Airport with professional drivers and comfortable vehicles for stress-free travel."
},
{
WhyChooseheading: "Professional and Experienced Drivers",
WhyChoosedescription: "Our trained chauffeurs ensure safe driving, punctual service, route knowledge, and a pleasant travel experience for every passenger."
},
{
WhyChooseheading: "Corporate and Business Travel Support",
WhyChoosedescription: "Many companies and professionals rely on Mumbai Airport Cabs for meetings, conferences, client visits, and regular corporate transportation."
},
{
WhyChooseheading: "Comfortable Travel for Families and Groups",
WhyChoosedescription: "From solo travelers to large family groups, we offer suitable vehicle options with ample seating and luggage space."
}
]
};

const faqData = [
{
question: "What services are included in Cab Service in Mumbai?",
answer: "Mumbai Airport Cabs offers local city rides, airport transfers, outstation cab services, corporate travel, sightseeing tours, and customized transportation solutions."
},
{
question: "Can I book a cab for Mumbai Airport transfers?",
answer: "Yes, airport pickup and drop services are available for Terminal 1, Terminal 2, domestic, and international travelers."
},
{
question: "Which vehicles are available for booking?",
answer: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles."
},
{
question: "Do you provide outstation cab services from Mumbai?",
answer: "Yes, outstation cab services are available for Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Ahmedabad, Indore, and many other destinations."
},
{
question: "Can corporate clients use this service regularly?",
answer: "Yes, we provide regular transportation solutions for corporate offices, executives, employees, and business travelers."
},
{
question: "Are Tempo Travellers available for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family trips, corporate outings, weddings, and group tours."
},
{
question: "Can I schedule a cab in advance?",
answer: "Yes, advance bookings are recommended to secure your preferred vehicle and travel schedule."
},
{
question: "Do you provide city sightseeing cabs in Mumbai?",
answer: "Yes, customers can book cabs for Mumbai Darshan, tourist attractions, shopping trips, and customized city tours."
},
{
question: "Are your drivers experienced and verified?",
answer: "Yes, all drivers are experienced, professionally trained, and familiar with Mumbai routes and travel requirements."
},
{
question: "How can I book a Cab Service in Mumbai?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Rajesh Mehta",
feedback:
"The service was extremely professional and punctual. The vehicle arrived on time, the driver was courteous, and the overall travel experience was excellent.",
rating: 5
},
{
id: 2,
name: "Mrs. Priya Kapoor",
feedback:
"Mumbai Airport Cabs has become our preferred travel partner for airport transfers and outstation trips. The vehicles are always clean and the service is consistently reliable.",
rating: 5
}
];










































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Service in Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/cab-service-in-mumbai.jpg",
"description": "Book reliable cab service in Mumbai for local rides, airport transfers, corporate travel, family trips, and outstation journeys. Mumbai Airport Cabs offers 24x7 taxi service with professional drivers, clean vehicles, affordable pricing, and easy online booking.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/cab-service-in-mumbai"
}
};





    return (
        <div>



<Helmet>
  <title>Cab Service in Mumbai | 24x7 Taxi Booking | +91 9545731161</title>

<meta
 name="description"
 content="Book cab service in Mumbai for local travel, airport transfers, outstation trips, and corporate rides. 24x7 reliable taxi service with affordable fares, instant booking, and professional drivers."
/>

<meta
 name="keywords"
 content="cab service in mumbai, mumbai cab service, mumbai taxi service, best cab service mumbai, 24x7 cab service mumbai, affordable cab service mumbai, mumbai car hire service, local cab service mumbai, mumbai outstation cab service, mumbai airport cab service, mumbai corporate cab service, mumbai family cab service, mumbai online cab booking, instant cab booking mumbai, reliable cab service mumbai, mumbai city cab service, mumbai ride service, mumbai travel cab service, mumbai budget cab service, mumbai premium cab service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/86.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinmumbai;